import { useDisclosure, MenuItem } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { FormattedMessage, useIntl } from 'react-intl';

import DownloadModal from '../utils/DownloadModal';
import Tooltip from '../utils/Tooltip';
import CircularIconButton from '../utils/CircularIconButton';
import SecondaryIconButton from '../utils/SecondaryIconButton';

import { ReactComponent as DownloadIcon } from '../../icons/download.svg';
import { ReactComponent as CircledDownloadIcon } from '../../icons/download-circled.svg';

const DownloadButton = ({
    itemId,
    type,
    filters,
    hasLabel,
    itemType,
    isInsideMenu = false,
    templateId,
    basisDataSorting,
    batteryDataSorting,
    ...rest
}) => {
    const intl = useIntl();
    const downloadModal = useDisclosure();

    return (
        <>
            {isInsideMenu ? (
                <MenuItem key="download-btn" {...rest} textTransform="capitalize" onClick={downloadModal.onOpen}>
                    <FormattedMessage id="common_download_btn_tooltip_and_label" />
                </MenuItem>
            ) : hasLabel ? (
                <SecondaryIconButton
                    leftIcon={<DownloadIcon />}
                    size="sm"
                    type="button"
                    variant="secondary"
                    onClick={downloadModal.onOpen}
                    {...rest}
                >
                    <FormattedMessage id="common_download_btn_tooltip_and_label" />
                </SecondaryIconButton>
            ) : (
                <TooltipWrapper>
                    <Tooltip label={intl.formatMessage({ id: 'common_download_btn_tooltip_and_label' })}>
                        <CircularIconButton
                            aria-label={intl.formatMessage({
                                id: 'common_download_btn_tooltip_and_label',
                            })}
                            icon={<CircledDownloadIcon />}
                            onClick={downloadModal.onOpen}
                            mr={6}
                        />
                    </Tooltip>
                </TooltipWrapper>
            )}

            {downloadModal.isOpen && (
                <DownloadModal
                    isOpen
                    onClose={downloadModal.onClose}
                    item={type}
                    itemId={itemId}
                    filters={filters}
                    itemType={itemType}
                    templateId={templateId}
                    basisDataSorting={basisDataSorting}
                    batteryDataSorting={batteryDataSorting}
                    {...rest}
                />
            )}
        </>
    );
};

const TooltipWrapper = styled.div`
    .tooltip_wrapper {
        transform: translate(-70%, 110%);
        &:focus {
            transform: translate(-70%, 110%);
        }
    }

    .tooltip_children_wrapper + div {
        transform: translate(-70%, 110%);
        &:focus {
            transform: translate(-70%, 110%);
        }
    }
`;

export default DownloadButton;
